export enum AppRoutesEnum {
  ABOUT = '/about',
  AUTH = '/auth',
  CONTACT = '/contact',
  HOME = '/',
  ENDPOINT_SERVICE = '/endpoint-service',
  ENDPOINT_SERVICE_DETAIL = '/endpoint-service/:id',
  DEVELOPMENT_PROGRAM = '/development-program',
}
